export default '/build/27b05617.jpg'